<template>
  <b-row class="match-height" v-if="localUserEvaluation && userData">
    <b-col>
      <b-card>
        <b-row class="h-100">
          <b-col cols="6" class="d-flex flex-column justify-content-between border-right">

            <div class="d-flex align-items-center">
              <b-avatar size="50px" variant="light-secondary" />
              <div class="ml-1">
                <h4>{{ localUserEvaluation.users.fullName }}</h4>
                <p class="card-text">
                  {{ localUserEvaluation.users.fonction || 'Fonction non renseignée' }}
                </p>
              </div>
            </div>

            <div>
              <b-button variant="outline-secondary" class="mb-75" block  @click="generateAutoPDF">
                Télécharger
              </b-button>

              <b-button
                  v-if="showUpdateButton"
                  variant="outline-secondary" class="mb-75" block
                  :to="{
                          name: isHierarchyModifying ? 'evaluation' : 'autoevaluation',
                          query: { id: localUserEvaluation.idPublic, userId: localUserEvaluation.users.id, year: currentYear }
                        }">
                Modifier
              </b-button>

            </div>
          </b-col>

          <b-col cols="6">
            <h4 class="text-primary">Information</h4>
            <hr>

            <b-card v-if="localUserEvaluation.status === 'TERMINATED' || (localUserEvaluation.dateEvaluationPrevu && localUserEvaluation.rhProposeDate && !localUserEvaluation.validHierachy) || (localUserEvaluation.status === 'MEETING' && localUserEvaluation.dateEvaluationPrevu) || (localUserEvaluation.status === 'EVALUATION' && localUserEvaluation.dateEvaluationPropose) ">
              <h5>Date de rencontre</h5>

              <p v-if="localUserEvaluation.dateEvaluationPrevu && localUserEvaluation.rhProposeDate && !localUserEvaluation.validHierachy">
                Le rendez-vous pour l'entretien a été définie par le Service des Ressources Humaines à la date du :
                <strong>{{ localUserEvaluation.dateEvaluationPrevu }}</strong>
              </p>

              <p v-if="localUserEvaluation.dateEvaluationPrevu && !localUserEvaluation.rhProposeDate">
                Le rendez-vous pour la validation de l'évaluation a été retenu à la date du :
                <strong>{{ localUserEvaluation.dateEvaluationPrevu }}</strong>
              </p>

              <p v-if="localUserEvaluation.dateEvaluationPropose">
                {{ localUserEvaluation.users.usersHierarchique[0].civilityFullName }}
                a proposé la date du <strong>{{ localUserEvaluation.dateEvaluationPropose }}</strong>.
              </p>
              <p v-if="localUserEvaluation.dateEvaluationSuggest">  {{ localUserEvaluation.users.civilityFullName }} a suggéré la date du
                <strong>{{ localUserEvaluation.dateEvaluationSuggest }}</strong>
              </p>

              <div v-if=" !isRapport && (localUserEvaluation.status === 'TERMINATED'||localUserEvaluation.status === 'EVALUATION') && !localUserEvaluation.valid">
                <hr class="my-2">

                <div v-if="!isHierarchyModifying">

                  <b-card-text
                      v-if="!localUserEvaluation.dateEvaluationSuggest && localUserEvaluation.dateEvaluationPropose">

                    <p class="mt-1">Vous avez 3 jours calendaires pour accepter la suggestion, proposer une nouvelle
                      date
                      ou maintenir votre choix. Passé ce délai, la
                      date initialement définie sera définitive.</p>
                    <hr class="my-2">
                  </b-card-text>

                  <div class="d-flex " v-if="localUserEvaluation.dateEvaluationPropose">
                    <b-form-group>
                      <b-form-checkbox
                          class="custom-control-primary mb-0"
                          name="check-button"
                          v-model="dateEvaluationAccepted"
                          switch
                      >
                        Valider date proposée
                      </b-form-checkbox>
                    </b-form-group>

                    <hr class="my-2">
                  </div>

                  <div class="d-flex justify-content-end">
                    <div>

                      <div v-if="!dateEvaluationAccepted">
                        <evaluation-date-scheduler
                            :user-data="userData"
                            :current-year="currentYear"
                            :manager="false"
                            :user-evaluation.sync="localUserEvaluation"
                        />
                      </div>

                      <div class="d-flex"
                           v-if="!localUserEvaluation.dateEvaluationPrevu && localUserEvaluation.dateEvaluationPropose">
                        <b-button variant="primary" @click="validateProposedDate" v-if="dateEvaluationAccepted">
                          <feather-icon size="16" icon="CheckIcon" class="mr-50"/>
                          <span class="align-middle"> Valider </span>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div v-if="showDateScheduler" class="d-flex justify-content-end">

                <evaluation-date-scheduler
                    :user-data="userData"
                    :current-year="currentYear"
                    :manager="isHierarchyModifying"
                    :user-evaluation.sync="localUserEvaluation"
                />
              </div>
              <div
                  v-if="!isRapport && isHierarchyModifying  && (localUserEvaluation.status === 'EVALUATION' || localUserEvaluation.status === 'TERMINATED') && localUserEvaluation.dateEvaluationSuggest !== null">
                <b-card-text v-if="localUserEvaluation.dateEvaluationSuggest">

                  <p class="mt-1">Vous avez 3 jours calendaires pour accepter la suggestion, proposer une nouvelle date
                    ou maintenir votre choix. Passé ce délai, la
                    date initialement définie sera définitive.</p>
                  <hr class="my-2">
                </b-card-text>

                <b-form-group>
                  <b-form-checkbox
                      class="custom-control-primary mt-1"
                      name="check-button"
                      v-model="dateEvaluationAccepted"
                      switch
                  >
                    Accepter date suggérée
                  </b-form-checkbox>
                </b-form-group>

                <div v-if="!dateEvaluationAccepted" class="d-flex justify-content-end">
                  <evaluation-date-scheduler
                      :user-data="userData"
                      :current-year="currentYear"
                      :manager="isHierarchyModifying"
                      :user-evaluation.sync="userEvaluation"
                  />
                </div>

                <hr class="my-2"/>

                <div class="d-flex justify-content-end">
                  <b-button variant="primary" @click="validateDateEvaluation" v-if="dateEvaluationAccepted">
                    <feather-icon size="16" icon="CheckIcon" class="mr-50"/>
                    <span class="align-middle"> Valider </span>
                  </b-button>

                  <b-button variant="primary" @click="maintainDate" v-else>
                    <span class="align-middle"> Maintenir proposition </span>
                  </b-button>
                </div>
              </div>


            </b-card>

            <b-card v-if="!isHierarchyModifying && !isN2 && !isRapport && localUserEvaluation.validHierachy && !localUserEvaluation.valid">
              <div>
                <h6 class="mb-3 text-justify">
                  Veuillez noter que vous avez 7 jours calendaires pour effectuer cette validation. Passé ce délai, la validation sera automatique.
                </h6>

                <b-form-group>
                  <b-form-checkbox
                      class="custom-control-primary"
                      name="check-button"
                      v-model="isValidated"
                      switch
                  >
                    Accepter évaluation
                  </b-form-checkbox>
                </b-form-group>

                <validation-observer ref="Commentaire1" tag="form">

                  <b-form-group v-if="!isValidated || localUserEvaluation.description">
                      <label for="textarea-default" class="font-weight-bold">Commentaire</label>
                      <validation-provider name="Commentaire" rules="required|noHtmlCode"
                                           v-slot="{ errors, failedRules }">
                      <b-form-textarea
                          id="textarea-default"
                          v-model="localUserEvaluation.description"
                          placeholder="Ajoutez un commentaire..."
                          rows="3"
                      />
                        <small class="text-danger" v-if="failedRules.required">
                          Un commentaire est requis.
                        </small>

                        <small class="text-danger" v-else-if="failedRules.noHtmlCode">
                          Le commentaire ne doit pas contenir de code HTML ou JavaScript.
                        </small>

                      </validation-provider>
                    </b-form-group>
                    <b-button variant="primary" class="mb-75" block @click="confirmEvalueEvaluation">
                      Envoyer
                    </b-button>
                </validation-observer>

              </div>
            </b-card>

            <b-card v-if="localUserEvaluation.descriptionRejet && (isHierarchyModifying || isN2)">
              <span class="text-danger">Commentaire de rejet :</span>
              {{ localUserEvaluation.descriptionRejet }}
            </b-card>

            <b-card v-if="(localUserEvaluation.status === 'REJECTED' || localUserEvaluation.status === 'TRANSMIT_HIERARCHY_2') && isN2">
                <div >
                  <b-form-group>
                    <b-card-title>Confirmation</b-card-title>

                    <b-card-text>
                      Si vous êtes en accord avec l'évaluation, confirmez l'évaluation puis cliquer sur le bouton "Envoyer".
                    </b-card-text>
                    <hr>
                    <b-form-checkbox
                        checked="true"
                        class="custom-control-primary mt-1"
                        name="check-button"
                        v-model="isEvaluationConfirmed"
                        switch
                    >
                      Confirmer évaluation
                    </b-form-checkbox>
                  </b-form-group>

                  <hr>
                  <b-button v-if="isEvaluationConfirmed" variant="primary" class="mb-75" block
                            @click="hierarchy2ConfirmEvaluation('validate')">
                    Envoyer
                  </b-button>
                  <b-button
                      v-if="!isEvaluationConfirmed"
                      variant="danger" class="mb-75" block @click="showRejectModal">
                    Rejeter
                  </b-button>
                </div>

              </b-card>

            <b-card v-if="localUserEvaluation.description || localUserEvaluation.descriptionAutomatic"
                    title="Commentaire Validation">
              <b-card-text class="text-danger">{{
                  localUserEvaluation.descriptionAutomatic
                }}
              </b-card-text>
              <b-card-text>
                {{
                  localUserEvaluation.description
                }}
              </b-card-text>
            </b-card>


            <!-- Card "Aucune information" conditionnelle -->
            <b-card v-if="hasNoInformation" class="d-flex flex-column justify-content-center align-items-center position-relative overflow-hidden" style="height: calc(100% - 50px); min-height: 140px">
              <div class="text-center text-muted">
                <p class="mb-0">Aucune information</p>
              </div>

              <b-img
                  src="@/assets/images/logo/SIRAT_COULEUR.png"
                  alt="logo"
                  class="position-absolute"
                  style="bottom: 0; right: 0; opacity: .5; width: auto; max-height: calc(100% - 20px); height: auto;"
              />


            </b-card>

          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <!-- TIMELINE -->
    <b-col cols="12" xl="5">
      <view-evaluation-timeline
          :user-data="userData"
          :user-evaluation="localUserEvaluation"
          :signature-valid-user="signatureValidUser"
          :current-year="currentYear"
      />
    </b-col>

    <!-- MODAL REJET -->
    <validation-observer ref="validationReject" tag="form">
      <b-modal
          id="reject-modal"
          title="Rejeter l'évaluation"
          v-model="isRejectModal"
          centered
          size="sm"
          @ok="handleModalOk"
          cancel-title="Annuler"
          ok-title="Confirmer le rejet"
      >
        <!-- Champ de commentaire avec validation -->
        <validation-provider
            name="Commentaire de rejet"
            rules="required|noHtmlCode"
            v-slot="{ errors, failedRules }"
        >
          <b-form-group
              label="Commentaire de rejet"
              label-for="rejection-comment"
              :state="errors.length ? false : null"
              class="mt-1"
          >
            <b-form-textarea
                id="rejection-comment"
                v-model="commentRejet"
                placeholder="Expliquez la raison du rejet..."
                rows="3"
                :state="errors.length ? false : null"
            />

            <b-form-invalid-feedback class="text-danger" v-if="failedRules.required">
              Un commentaire est requis.
            </b-form-invalid-feedback>

            <b-form-invalid-feedback class="text-danger" v-else-if="failedRules.noHtmlCode">
              Le commentaire ne doit pas contenir de code HTML ou JavaScript.
            </b-form-invalid-feedback>

          </b-form-group>
        </validation-provider>
      </b-modal>
    </validation-observer>
  </b-row>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BRow,
  BModal,
  BFormTextarea,
  BFormCheckbox, BImg, BCardText
} from 'bootstrap-vue'

import EvaluationDateScheduler from '@/views/profil/EvaluationDateScheduler.vue'
import ViewEvaluationTimeline from '@/views/evaluation/ViewEvaluationTimeline.vue'
import {
  updateDateEvaluationMeeting,
  updateUserEvaluations,
  updateUserEvaluationValid
} from '@/services/UserEvaluationService'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import { required } from "@core/utils/validations/validations";
import logoSIRAT from "@/assets/images/logo/LOGO_SIRAT_couleur.png";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import autoTable from "jspdf-autotable";
import {getBase64Image} from "@/util/getBase64Image";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

extend('required', {
  ...required,
  message: '{_field_} est obligatoire.'
})
const forbiddenPatterns = [
      /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
      /<\s*script/i,
      /<\s*style/i,
      /on\w+\s*=/i,
      /(javascript|data|vbscript):/i,
      /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
      /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
  /<!--|--\>/i
];
extend('noHtmlCode', {
  validate: (value) => {
    if (!value) return true; // vide ok
    // Vérifie chaque pattern du tableau
    for (const pattern of forbiddenPatterns) {
      if (pattern.test(value)) {
        return false; // interdit si un pattern match
      }
    }
    return true; // tout est ok
  },
  message: 'Le texte ne doit pas contenir de code HTML ou JavaScript.',
});

export default {
  components: {
    BCardText,
    BImg,
    BAvatar,
    BButton,
    BCard,
    BCol,
    BRow,
    BModal,
    BFormTextarea,
    BFormCheckbox,
    EvaluationDateScheduler,
    ViewEvaluationTimeline,
    ValidationProvider,
    ValidationObserver
  },

  props: {
    userEvaluation: Object,
    userData: Object,
    currentYear: Number,
    isHierarchyModifying: Boolean,
    isAfter: Boolean,
    isBetween: Boolean,
    isRapport: Boolean,
    isN2: Boolean,
    isAutoEval: Boolean,
    componentSections:{
      type: Array,
      default: null
    },
  },

  data() {
    return {
      localUserEvaluation: null,
      isRejectModal: false,
      commentRejet: '',
      comment: '',
      isEvaluationValidated: false,
      dateEvaluationAccepted: true,
      isValidated: true,
      isEvaluationConfirmed: true,
      signatureValidUser: [],

    }
  },

  watch: {
    userEvaluation: {
      immediate: true,
      deep: true,
      handler(val) {
        this.localUserEvaluation = val
            ? JSON.parse(JSON.stringify(val))
            : null

        this.processUserEvaluation();
      }

    },

  },

  computed: {
    showUpdateButton() {
      if (!this.localUserEvaluation) return false;
      if (this.isRapport) return false;
      if (this.isBetween) return false;
      const status = this.localUserEvaluation.status;

      if (['VALIDATED_BY_COLLABORATOR', 'APPROVED'].includes(status)) {
        return false;
      }

      if (this.isN2) return false;

      if (this.isAfter) {
        return this.isHierarchyModifying;
      }
      return true;

      // if (this.isAfter) {
      //   return this.isHierarchyModifying && !this.isN2;
      // }
      // return !this.isN2 &&
      //     this.localUserEvaluation.status !== 'VALIDATED_BY_COLLABORATOR' &&
      //     this.localUserEvaluation.status !== 'APPROVED';


    },

    showDateScheduler() {
      if (!this.isHierarchyModifying || !this.localUserEvaluation) return false;

      const status = this.localUserEvaluation.status;
      const datePrevu = this.localUserEvaluation.dateEvaluationPrevu;
      const dateSuggest = this.localUserEvaluation.dateEvaluationSuggest;

      // Empêcher Manager de Modifier la date définie par les Ressources Humaines
      if (this.localUserEvaluation.dateEvaluationPrevu && this.localUserEvaluation.rhProposeDate) return false

      // Si on est en MEETING avec date prévue mais pas encore dépassée
      if (status === 'MEETING' && datePrevu && !this.isAfter && !this.isBetween) return true;

      // Si TERMINATED et pas de suggestion de date
      if ((status === 'TERMINATED' || status === 'EVALUATION') && !dateSuggest) return true;

      // if (proposeDate===2) return false;
      return false;
    },

    hasNoInformation() {



      const hasMeetingInfo =
          this.localUserEvaluation.status === 'TERMINATED' ||
          (this.localUserEvaluation.dateEvaluationPrevu && this.localUserEvaluation.rhProposeDate && !this.localUserEvaluation.validHierachy) ||
          (this.localUserEvaluation.status === 'MEETING' && this.localUserEvaluation.dateEvaluationPrevu) ||
          (this.localUserEvaluation.status === 'EVALUATION' && this.localUserEvaluation.dateEvaluationPropose) ;
      const hasCollaboratorValidation =
          !this.isHierarchyModifying &&
          !this.isN2 &&
          !this.isRapport &&
          this.localUserEvaluation.validHierachy &&
          !this.localUserEvaluation.valid;

      const hasRejectionComment = this.localUserEvaluation.descriptionRejet && (this.isHierarchyModifying || this.isN2);

      const hasN2Confirmation =
          (this.localUserEvaluation.status === 'REJECTED' || this.localUserEvaluation.status === 'TRANSMIT_HIERARCHY_2') &&
          this.isN2;

      const hasDateScheduler =
          this.showDateScheduler ||
          (!this.isRapport && this.isHierarchyModifying &&
              (this.localUserEvaluation.status === 'EVALUATION' || this.localUserEvaluation.status === 'TERMINATED') &&
              this.localUserEvaluation.dateEvaluationSuggest !== null);


      const hasDescription = this.localUserEvaluation.description || this.localUserEvaluation.descriptionAutomatic;
      return !(
          hasMeetingInfo ||
          hasCollaboratorValidation ||
          hasRejectionComment ||
          hasN2Confirmation ||
          hasDateScheduler ||
          hasDescription
      );
    },
  },

  methods: {

    addSignatureUser(titre, users, signature, dateCreate, text, variant) {
      if (!users) return;
      this.signatureValidUser.push({ titre, users, signature, dateCreate, text, variant });
    },

    processUserEvaluation() {
      this.signatureValidUser = [];
      if (!this.localUserEvaluation) return;

      const { status, users, dateCreate, dateValid, evaluationSignature = [], dateEvaluationPropose, dateEvaluationSuggest, dateEvaluationPrevu, rhProposeDate, autoEvaluationFin } = this.localUserEvaluation;
      const n1 = evaluationSignature.find(item => item.hierarchyN === 1);
      const n2 = evaluationSignature.find(item => item.hierarchyN === 2);

      switch (status) {
        case 'INPROGRESS':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation en cours', 'warning');
          break;
        case 'SELF_EVALUATION':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation effectuée', 'success');
          if (n1?.users) {
            this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de l\'évaluation de la part du manager', 'warning');
          }
          break;
        case 'EVALUATION':
          if (n1?.users) {
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');
            if (dateEvaluationPropose) {
              this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'Date de réunion d’évaluation proposée', 'success');
            }

          }
          this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de l\'auto-évaluation de la part du collaborateur', 'warning');
          break;
        case 'TERMINATED':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');
          if (n1?.users ) {
            if (dateEvaluationPrevu && rhProposeDate) {
              this.addSignatureUser('Rendez-vous :', users, false, dateEvaluationPrevu, 'Le rendez-vous pour la validation de l\'évaluation a été retenu à la date du : ' + dateEvaluationPrevu, 'warning');
            }
            if (!dateEvaluationPropose && !rhProposeDate) {
              this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de la définition d\'une date pour l\'évaluation', 'warning');

            }
            if (dateEvaluationPropose) {
              if (dateEvaluationSuggest){

                this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'Date de réunion d’évaluation proposée', 'success');
                this.addSignatureUser('Collaborateur :', users, false, null, 'Une autre date de réunion suggérée', 'success');
                this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de validation de la date suggérée', 'warning');

              }else{
                this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'Date de réunion d’évaluation proposée', 'success');
                this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de validation de la date proposée', 'warning');

              }
            }
          }
          break;
        case 'MEETING':
          if (autoEvaluationFin) {
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

          this.addSignatureUser('Rendez-vous :', users, false, dateEvaluationPrevu, 'Le rendez-vous pour la validation de l\'évaluation a été retenu à la date du : ' + dateEvaluationPrevu, 'warning');
          }else{
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

            this.addSignatureUser('Rendez-vous :', users, false, dateEvaluationPrevu, 'Le rendez-vous pour la validation de l\'évaluation a été retenu à la date du : ' + dateEvaluationPrevu, 'warning');
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'En attente de l\'auto-évaluation de la part du collaborateur', 'warning');

          }
          break;
        case 'VALIDATED_BY_HIERARCHY':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');
          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation Validée', 'success');
          this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de confirmation de l\'évaluation par le collaborateur', 'warning');
          break;
        case 'TRANSMIT_HIERARCHY_2':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');
          if (this.isRapport || this.isN2 || this.isHierarchyModifying) {
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation validée', 'success');

            if (n2?.users) {
              this.addSignatureUser('Manager N°2 :', n2.users, false, null, 'En attente d\'approbation par le manager N+2', 'warning');
            }
          } else {
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation en attente de validation par le N+1.', 'warning');
          }

          break;
        case 'APPROVED':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation validée', 'success');

          if (this.isRapport || this.isN2 || this.isHierarchyModifying) {
            this.addSignatureUser('Manager N°2 :', n2?.users, true, n2?.confirmDate, 'Approbation du Manager N+2', 'success');
          }
          this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de validation par le collaborateur', 'warning');
          break;
        case 'VALIDATED_BY_COLLABORATOR':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');
          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation validée', 'success');
          if ((this.isRapport || this.isN2 || this.isHierarchyModifying) && n2) {
            this.addSignatureUser('Manager N°2 :', n2.users, true, n2.confirmDate, 'Évaluation approuvée', 'success');
          }
          this.addSignatureUser('Collaborateur :', users, true, dateValid, 'Validation finale - Évaluation terminée', 'success');
          break;
        case 'REJECTED':
          this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

          this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

          if ((this.isRapport || this.isN2 || this.isHierarchyModifying) && n2) {
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation validée', 'success');
            this.addSignatureUser('Manager N°2 :', n2.users, false, n2.confirmDate, 'Évaluation rejetée par le Manager N+2', 'danger');
            this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de modification par le N+1', 'warning');

          }else{
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation en attente de validation par le N+1.', 'warning');

          }


          break;
      }

    },



    handleModalOk(bvModalEvt) {
      // Empêche la fermeture par défaut du modal
      bvModalEvt.preventDefault();

      // Valide le formulaire
      this.$refs.validationReject.validate().then((success) => {
        if (success && this.commentRejet) {
          // Si la validation passe et commentRejet n'est pas null, fermer le modal
          this.$nextTick(() => {
            this.hierarchy2ConfirmEvaluation('reject')
            this.$bvModal.hide('reject-modal');
          });
        } else {
          // Si la validation échoue ou commentRejet est null, ne rien faire
          this.showToast('Commentaire de rejet requis !', 'danger', 'EditIcon')
        }
      });
    },

    async hierarchy2ConfirmEvaluation(action) {
      try {
        // Set valid based on action and isEvaluationConfirmed
        if (action === 'validate' && !this.isEvaluationConfirmed ) {
          this.showToast(
              "Veuillez confirmer l'évaluation avant de valider.",
              "danger",
              "EditIcon"
          )
        } else if (action === 'reject') {
          this.localUserEvaluation.validHierachy = false;
        } else if (action === 'validate' && this.isEvaluationConfirmed) {
          this.localUserEvaluation.validHierachy = true;
        } else {
          this.showToast(
              "Veuillez confirmer l'évaluation avant de valider.",
              "danger",
              "EditIcon"
          );
          return;
        }

        // Update other properties
        this.localUserEvaluation.descriptionRejet = this.commentRejet;

        // Call the API to update the evaluation
        this.localUserEvaluation = await updateUserEvaluations(
            this.localUserEvaluation.idPublic,
            this.userData.id,
            true,
            this.localUserEvaluation
        );

        this.updateLocal(this.localUserEvaluation )

        // this.addAllSignatureUser(this.userEvaluation)

        if (action === 'reject') {
          this.showToast("Évaluation rejetée avec succès.",
              "success",
              "EditIcon"
          );
        } else {
          this.showToast("Succès de l'action.",
              "success",
              "EditIcon"
          );
        }

      } catch (error) {
        console.error(`Error ${action === 'reject' ? 'rejecting' : 'approving'} evaluation:`, error);
        this.showToast(
            `Erreur au cours ${action === 'reject' ? 'du rejet' : 'de l\'approbation'} de l'évaluation.`,
            "danger",
            "EditIcon"
        );
      }
    },

    confirmEvalueEvaluation() {
      // Nettoyer le commentaire
      const cleanComment = this.localUserEvaluation.description
          ? this.localUserEvaluation.description.trim()
          : '';

      if ((!cleanComment || cleanComment === '') && !this.isValidated) {
        this.showToast(
            "Veuillez ajouter un commentaire ou accepter l'évaluation avant de soumettre.",
            "danger",
            "EditIcon"
        );
        return;
      }

      this.localUserEvaluation.valid = this.isValidated;
      this.localUserEvaluation.description = cleanComment;

      updateUserEvaluationValid(
          this.localUserEvaluation.idPublic,
          this.userData.id,
          this.localUserEvaluation
      )
          .then(result => {
            this.updateLocal(result);

            if (this.isValidated) {
              if (cleanComment) {
                this.showToast(
                    "Évaluation validée avec commentaire avec succès.",
                    "success",
                    "EditIcon"
                );
              } else {
                this.showToast(
                    "Évaluation validée avec succès.",
                    "success",
                    "EditIcon"
                );
              }
            } else {
              this.showToast(
                  "Commentaire envoyé avec succès.",
                  "success",
                  "EditIcon"
              );
            }
          })
          .catch(error => {
            console.error('Error validating evaluation:', error);
            this.showToast(
                "Erreur dans la validation de l'évaluation.",
                "danger",
                "EditIcon"
            );
          });
    },
    showToast(message,color,icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: icon,
          variant: color,
        },
      });
    },
    // updateLocal(val) {
    //   this.localUserEvaluation = val
    //   this.$emit('update:userEvaluation', val)
    // },
    updateLocal(val) {
      // Créer une nouvelle référence pour forcer la réactivité
      this.localUserEvaluation = { ...val };

      this.processUserEvaluation()

      // Émettre l'objet mis à jour vers le parent
      this.$emit('update:user-evaluation', this.localUserEvaluation);
      this.$emit('update:signature-valid-user', this.signatureValidUser);
    },
    validateDateEvaluation(){
      updateDateEvaluationMeeting(this.localUserEvaluation.idPublic, this.localUserEvaluation, 'MANAGER_ACCEPT_SUGGEST')
          .then(result => {
              this.updateLocal(result)
            this.showToast(
                "Date suggérée enregistrée avec succès",
                "success",
                "BellIcon"
            );
          })
          .catch(error => {
            this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            console.error("Erreur lors de la récupération des données :", error);
          });
    },
    maintainDate(){
      updateDateEvaluationMeeting(this.localUserEvaluation.idPublic, this.localUserEvaluation, 'MAINTENIR')
          .then(result => {

            this.updateLocal(result)
            this.showToast("Date proposée maintenue avec succès", "success", "BellIcon");

          })
          .catch(error => {
            this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
          });
    },



    async validateProposedDate() {

      updateDateEvaluationMeeting(this.localUserEvaluation.idPublic, this.localUserEvaluation, 'USER_ACCEPT')
          .then(result => {

            this.updateLocal(result)

            this.showToast("Date enregistrée avec succès", "success", "BellIcon");
          })
          .catch(error => {
            this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            console.error("Erreur lors de la récupération des données :", error);
          });
    },
    showRejectModal() {
      this.isRejectModal = true
    },


    formatDate(date) {

      if (!date) return '';


      if (Array.isArray(date)) {
        const [year, month, day] = date;

        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }


      if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        const [year, month, day] = date.substring(0, 10).split('-');
        return `${day}-${month}-${year}`;
      }
      if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
        const [day, month, year] = date.split('-');
        return `${day}-${month}-${year}`;
      }
      if (date instanceof Date && !isNaN(date)) {
        return date.toLocaleDateString('fr-FR');
      }

      return '';
    },
    isStandard(sectionData) {
      return sectionData && sectionData.responseChoice === 'Standard';
    },

    async generateAutoPDF() {

      const titre =
          this.isAutoEval === null || this.isAutoEval === undefined
              ? "Comparaison"
              : this.isAutoEval
                  ? "Évaluation"
                  : "Auto-évaluation";

      const orientation =
          this.isAutoEval === null || this.isAutoEval === undefined
          ? 'landscape'
          : 'portrait';

      const docDefinition = {
        pageMargins: [40, 20, 40, 60],

        pageSize: 'A4',
        pageOrientation: orientation,
        content: [],
        styles: {
          section: { fontSize: 12, bold: false, color: '#005cb9', margin: [0, 8, 0, 4] }
        },

        footer: function(currentPage, pageCount) {
          const BLUE = '#005cb9';
          const BLACK = '#020202';

          return {
            stack: [
              {
                text: "Société des Infrastructures Routières et de l’Aménagement du Territoire (SIRAT SA), Société Anonyme au capital social de 100.000.000 F.CFA -",
                fontSize: 8, color: BLUE, alignment: 'center', margin: [0, 10, 0, 0]
              },
              {
                text: "Siège : Immeuble SCI Trait d’Union, von Obama Beach, Quartier Ahwanleko Plage, Cotonou -",
                fontSize: 8, color: BLUE, alignment: 'center', margin: [0, 2, 0, 0]
              },
              {
                text: "Tél : 21 60 45 45 - IFU : 3 2018 1038 7789 - RCCM RB/COT/18 B 22225 ; contact@sirat.bj",
                fontSize: 8, color: BLUE, alignment: 'center', link: "mailto:contact@sirat.bj", margin: [0, 2, 0, 0]
              },
              {
                text: `Page ${currentPage} / ${pageCount}`,
                fontSize: 8, color: BLACK, alignment: 'right', margin: [0, 4, 10, 0]
              }
            ]
          };
        }
      };



      // Logo et titre
      const logoBase64 = await getBase64Image(logoSIRAT);
      docDefinition.content.push({
        columns: [
          { image: logoBase64, width: 120 },
          {
            stack: [
              {
                text: `${titre} ${this.localUserEvaluation?.years}`,
                alignment: 'right',
                fontSize: 12,
                bold: false,
                color: '#005cb9'
              },
              {
                text: `Statut : ${this.localUserEvaluation.valid ? 'Validé' : 'Non Validé'}`,
                alignment: 'right',
                fontSize: 11,
                margin: [0, 5, 0, 0]
              }
            ]
          }
        ],
        columnGap: 10
      });

      // Infos utilisateurs et sections
      if (this.isAutoEval === null || this.isAutoEval === undefined) {
        const sectionsContent = await this.buildThirdComponentSectionContent(this.componentSections);
        docDefinition.content.push(...sectionsContent);
      } else {
        const sectionsContent = await this.buildComponentSectionsContent(this.componentSections);
        docDefinition.content.push(...sectionsContent);
      }

      // Commentaires
      if (this.localUserEvaluation.description || this.localUserEvaluation.descriptionAutomatic) {
        docDefinition.content.push({ text: 'Commentaire de Validation', style: 'section' });

        if (this.localUserEvaluation.descriptionAutomatic) {
          docDefinition.content.push({ text: this.localUserEvaluation.descriptionAutomatic, color: 'red', margin: [0,2,0,6] });
        }

        if (this.localUserEvaluation.description) {
          docDefinition.content.push({ text: this.localUserEvaluation.description, margin: [0,2,0,6] });
        }
      }

      if (this.localUserEvaluation.descriptionRejet && (this.isHierarchyModifying || this.isN2)) {
        docDefinition.content.push({ text: 'Commentaire de rejet', style: 'section' });
        docDefinition.content.push({ text: this.localUserEvaluation.descriptionRejet, color: 'red', margin: [0,2,0,6] });
      }

      // Validation
      docDefinition.content.push({ text: 'Validation', style: 'section' });
      const signatureData = this.signatureValidUser.map(sig => [sig.titre, `${sig.users.lastName} ${sig.users.firstName}`, this.formatDate(sig.dateCreate), sig.text]);
      docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: ['*','*','*'],
          body: [['Nom & Prénom(s)', 'Date', 'Statut'], ...signatureData.map(row => [row[1], row[2], row[3]])]
        },
        layout: {
          hLineColor: '#575353',
          vLineColor: '#575353',
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5
        },
        bold: false,
        fontSize: 10,
        margin: [0,4,0,0]
      });

      pdfMake.createPdf(docDefinition).download(`AutoEvaluation_${this.localUserEvaluation.users.lastName}.pdf`);
    },
    async buildComponentSectionsContent(componentSections) {
      const content = [];
      const PRIMARY_COLOR = '#005cb9';

      for (const compSec of componentSections || []) {
        if (!compSec?.section) continue;

        const coef = compSec.section.coef ? ` | coef = ${compSec.section.coef}%` : "";

        // Titre de section
        content.push({
          text: `${compSec.section.title || ""}${coef}`,
          color: PRIMARY_COLOR,
          bold: false,
          fontSize: 12,
          margin: [0, 8, 0, 4]
        });

        // Description
        if (compSec.section.description) {
          content.push({
            text: compSec.section.description,
            bold: false,
            fontSize: 10,
            margin: [0, 2, 0, 6]
          });
        }

        // Info utilisateur
        if (compSec.section.position === 1 && this.localUserEvaluation?.users) {
          content.push(...await this.drawUserInfoTable());
        }

        // Sections standard
        if (this.isStandard?.(compSec.section)) {
          for (const contentSec of compSec.content || []) {
            for (const cs of contentSec.contentSections || []) {
              const tableBody = [];
              const row = [ { text: cs.titre || '', bold: false } ];

              cs.valueComponentModels?.forEach((val, colIndex) => {
                const csRef = contentSec.contentSections?.[colIndex]; // correspond à la colonne
                let cellText = String(val ?? "");
                if (Array.isArray(val)) {
                  cellText = val.map((item, i) => `${i + 1}. ${item}`).join("\n");
                }
                row.push({
                  text: cellText,
                  bold: false,
                  fontSize: 10,
                  alignment: this.getAlignment(csRef),
                  margin: [4, 2, 4, 2]
                });
              });

              tableBody.push(row);

              content.push({
                table: { widths: Array(row.length).fill('*'), body: tableBody },
                layout: {
                  hLineColor: '#575353',
                  vLineColor: '#575353',
                  hLineWidth: () => 0.5,
                  vLineWidth: () => 0.5
                },
                bold: false,
                fontSize: 10,
                margin: [0, 4, 0, 8]
              });
            }
          }
          continue;
        }

        // Sections non-standard
        for (const contentSec of compSec.content || []) {
          if (!contentSec?.componentModels?.length) continue;
          const hasSingleWithSum = contentSec.contentSections.length === 1 && contentSec.contentSections[0].somme;
          const headRow = hasSingleWithSum
              ? [{
                text: contentSec.contentSections[0].titre, bold: false, alignment: 'center',
                margin: [4, 2, 4, 2]
              }]
              : [
                {text: "", bold: false},
                ...contentSec.contentSections.map(cs => ({
                  text: cs.titre || '', bold: false, fontSize: 10,
                  alignment: 'center',
                  margin: [4, 2, 4, 2]
                })),
              ];

          const bodyRows = contentSec.componentModels.map(cm => {
            const row = hasSingleWithSum ? [] :[ { text: cm.titre || '', bold: false , fontSize: 10,
              alignment: 'justify',
              margin: [4, 2, 4, 2]} ];
            cm.valueComponentModels?.forEach((val, colIndex) => {
              const csRef = contentSec.contentSections?.[colIndex];
              let cellText = String(val ?? "");

              if (Array.isArray(val)) {
                cellText = val.map((item, i) => `${i + 1}. ${item}`).join("\n");
              }
              row.push({
                text: cellText,
                bold: false,
                fontSize: 10,
                alignment: hasSingleWithSum ?'center' :this.getAlignment(csRef),
                margin: [4, 2, 4, 2] });
            });
            return row;
          });

          content.push({
            table: {
              widths: Array(headRow.length).fill('*'),
              body: [headRow, ...bodyRows]
            },
            layout: {
              hLineColor: '#575353',
              vLineColor: '#575353',
              hLineWidth: () => 0.5,
              vLineWidth: () => 0.5
            },
            bold: false,
            fontSize: 10,
            margin: [0, 4, 0, 8]
          });
        }
      }

      return content;
    },


    async buildThirdComponentSectionContent(componentSections) {
      const content = [];
      const PRIMARY_COLOR = '#005cb9';
      for (const compSec of componentSections || []) {
        if (!compSec?.section) continue;

        const coef = compSec.section.coef ? ` | coef = ${compSec.section.coef}%` : '';

        // ===== Titre de section =====
        content.push({
          text: `${compSec.section.title || ''}${coef}`,
          color: PRIMARY_COLOR,
          fontSize: 12,
          margin: [0, 8, 0, 4]
        });

        // ===== Description =====
        if (compSec.section.description) {
          content.push({
            text: compSec.section.description,
            fontSize: 10,
            margin: [0, 2, 0, 6]
          });
        }

        // ===== Infos utilisateur =====
        if (compSec.section.position === 1 && this.localUserEvaluation?.users) {
          content.push(...await this.drawUserInfoTable());
        }
        if (this.isStandard?.(compSec.section)) {
          for (const contentSec of compSec.content || []) {
            for (const cs of contentSec.contentSections || []) {

              // Ligne 1 : titre + Auto / Éval
              const headRow = [
                { text: cs.titre || '', rowSpan: 2, bold: true, alignment: 'center', fontSize: 10 },
                { text: 'Auto-Évaluation', alignment: 'center', bold: true, fontSize: 10 },
                { text: 'Évaluation', alignment: 'center', bold: true, fontSize: 10 }
              ];

              // Ligne 2 : valeurs Auto et Éval
              const autoRow = cs.valueComponentModels?.map((val, colIndex) => {
                const csRef = contentSec.contentSections?.[colIndex]; // correspond à la colonne

                let text = '';
                if (Array.isArray(val?.auto)) {
                  text = val.auto.map((item, i) => `${i + 1}. ${item}`).join('\n');
                } else {
                  text = String(val?.auto ?? '');
                }
                return {
                  text,
                  fontSize: 10,
                  alignment: this.getAlignment(csRef),
                  margin: [4, 2, 4, 2]
                };
              }) ?? [];

              const evalRow = cs.valueComponentModels?.map((val, colIndex) => {
                const csRef = contentSec.contentSections?.[colIndex]; // correspond à la colonne

                let text = '';
                if (Array.isArray(val?.eval)) {
                  text = val.eval.map((item, i) => `${i + 1}. ${item}`).join('\n');
                } else {
                  text = String(val?.eval ?? '');
                }
                return {
                  text,
                  fontSize: 10,
                  alignment: this.getAlignment(csRef),
                  margin: [4, 2, 4, 2]
                };
              }) ?? [];

              // Construire le tableau complet
              const tableBody = [
                headRow,
                [{} , ...autoRow, ...evalRow]
              ];

              content.push({
                table: {
                  widths: Array(tableBody[0].length).fill('*'),
                  body: tableBody
                },
                layout: {
                  hLineColor: '#575353',
                  vLineColor: '#575353',
                  hLineWidth: () => 0.5,
                  vLineWidth: () => 0.5
                },
                margin: [0, 4, 0, 8]
              });
            }
          }
          continue;
        }

        // ===== Parcours des sous-sections =====
        for (const contentSec of compSec.content || []) {
          if (!contentSec?.componentModels?.length) continue;
          const sectionCols = contentSec.contentSections || [];
          const sectionCount = sectionCols.length;
          const hasSingleWithSum = sectionCount === 1 && sectionCols[0].somme;
          const colCount = hasSingleWithSum ? 3 : 1 + sectionCount * 2;

          // ===== Cas normal (plusieurs colonnes) =====
          if (!hasSingleWithSum) {

            const headRow1 = [
              { text: compSec.section.title, rowSpan: 2, bold: true, fontSize: 10, alignment: 'center' },
              { text: 'Auto-Évaluation', colSpan: sectionCount, alignment: 'center', bold: true, fontSize: 10 },
              ...Array(sectionCount - 1).fill({}),
              { text: 'Évaluation', colSpan: sectionCount, alignment: 'center', bold: true, fontSize: 10 },
              ...Array(sectionCount - 1).fill({})
            ];

            const headRow2 = [
              {},
              ...sectionCols.map(cs => ({ text: cs.titre || '', alignment: 'center', fontSize: 10 })),
              ...sectionCols.map(cs => ({ text: cs.titre || '', alignment: 'center', fontSize: 10 }))
            ];

            const bodyRows = contentSec.componentModels.map((cm, colIndex) => {
              const csRef = contentSec.contentSections?.[colIndex];

              const row = [{ text: cm.titre || '', fontSize: 10, alignment: 'justify', margin: [4,2,4,2] }];

              // AUTO
              sectionCols.forEach((_, i) => {
                const val = cm.valueComponentModels?.[i]?.auto;
                const csRef = contentSec.contentSections?.[i]; // correspond à la colonne

                row.push({
                  text: Array.isArray(val) ? val.map((v, idx) => `${idx + 1}. ${v}`).join('\n') : String(val ?? ''),
                  fontSize: 10,
                  alignment: this.getAlignment(csRef),
                  margin: [4,2,4,2]
                });
              });

              // EVAL
              sectionCols.forEach((_, i) => {
                const val = cm.valueComponentModels?.[i]?.eval;
                const csRef = contentSec.contentSections?.[i]; // correspond à la colonne

                row.push({
                  text: Array.isArray(val) ? val.map((v, idx) => `${idx + 1}. ${v}`).join('\n') : String(val ?? ''),
                  fontSize: 10,
                  alignment:this.getAlignment(csRef),
                  margin: [4,2,4,2]
                });
              });

              return row;
            });

            content.push({
              table: {
                widths: Array(colCount).fill('*'),
                body: [headRow1, headRow2, ...bodyRows]
              },
              layout: {
                hLineColor: '#575353',
                vLineColor: '#575353',
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5
              },
              margin: [0,4,0,8]
            });

          } else {
            // ===== Cas hasSingleWithSum (un seul total) =====
            // const bodyRows = contentSec.componentModels.map((cm, colIndex)  => {
            //   const csRef = contentSec.contentSections?.[colIndex]; // correspond à la colonne
            //
            //   ([
            //   { text: sectionCols[0]?.titre || cm.titre || '', fontSize: 10, bold: true, margin: [4,2,4,2] },
            //   { text: String(cm.valueComponentModels?.[0]?.auto ?? ''), alignment: this.getAlignment(csRef), fontSize: 10 },
            //   { text: String(cm.valueComponentModels?.[0]?.eval ?? ''), alignment: this.getAlignment(csRef), fontSize: 10 }
            // ])
            //
            // });
            const bodyRows = contentSec.componentModels.map((cm, colIndex) => {
              // const csRef = contentSec.contentSections?.[colIndex]; // correspond à la colonne

              return [
                { text: sectionCols[0]?.titre || cm.titre || '', fontSize: 10, bold: true, margin: [4,2,4,2] },
                {
                  text: String(cm.valueComponentModels?.[0]?.auto ?? ''),
                  alignment: 'center',
                  fontSize: 10
                },
                {
                  text: String(cm.valueComponentModels?.[0]?.eval ?? ''),
                  alignment: 'center',
                  fontSize: 10
                }
              ];
            });

            content.push({
              table: {
                widths: [143, '*', '*'],  // largeurs fixes pour aligner Auto/Eval
                body: bodyRows
              },
              layout: {
                hLineColor: '#575353',
                vLineColor: '#575353',
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5
              },
              margin: [0,4,0,8]
            });
          }
        }
      }

      return content;
    },


    async drawUserInfoTable() {

      const n1 = this.localUserEvaluation?.evaluationSignature?.find(item => item.hierarchyN === 1);
      const n2 = this.localUserEvaluation?.evaluationSignature?.find(item => item.hierarchyN === 2);

      const orientation =
            this.isAutoEval === null || this.isAutoEval === undefined
                ? "l"
                : "p";

      const content = [
        {
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                // 'Personne occupant le poste :',
                // `${this.userObjective.users.lastName} ${this.userObjective.users.firstName}`
                {
                  text: 'Personne occupant le poste :',
                  fillColor: '#f2f2f2',
                  fontSize: 10,
                  margin: [5, 4, 5, 4]
                },
                {
                  text: `${this.localUserEvaluation.users.lastName} ${this.localUserEvaluation.users.firstName}`,
                  fillColor: '#f2f2f2',
                 fontSize: 10,
                  margin: [5, 4, 5, 4]
                }
              ],
              [
                { text: this.localUserEvaluation?.users?.services?.name ? 'Service :' : 'Direction :', fontSize: 10 },
                { text: this.localUserEvaluation?.users?.services?.name || this.localUserEvaluation?.users?.directions?.name || '', fontSize: 10 }


              ],
              [
                { text: 'Fonction / Titre :', fontSize: 10 },
                { text: this.localUserEvaluation?.users?.fonction || '', fontSize: 10 }

              ],
              [ { text: 'Date de prise de service :', fontSize: 10 },
                { text: this.formatDate(this.localUserEvaluation?.users?.fonctionDate) || '', fontSize: 10 }
              ]
            ]
          },
          layout: 'noBorders',

          margin: [0, 12, 0, 16]
        }
      ]

      //  Manager N°1
      if (n1) {
        content.push({
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                {
                  text:  'Supérieur Hiérarchique 1 :',
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                },
                {
                  text: `${n1.users.lastName} ${n1.users.firstName}`,
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                }
              ],
              [
                { text: n1?.users?.services?.name ? 'Service :' : 'Direction :', fontSize: 10 },
                { text: n1?.users?.services?.name || n1?.users?.directions?.name || '', fontSize: 10 }


              ],
              [
                { text: 'Fonction / Titre :', fontSize: 10 },
                { text: n1?.users?.fonction || '', fontSize: 10 }

              ],
              [ { text: 'Date de prise de service :', fontSize: 10 },
                { text: this.formatDate(n1?.users?.fonctionDate) || '', fontSize: 10 }
              ]
            ]
          },
          layout: 'noBorders',

          margin: [0, 12, 0, 16]
        })
      }

      //  Manager N°2
      if (n2) {
        content.push({
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                {
                  text:  'Supérieur Hiérarchique 2 :',
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                },
                {
                  text: `${n2.users.lastName} ${n2.users.firstName}`,
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                }
              ],
              [
                { text: n2?.users?.services?.name ? 'Service :' : 'Direction :', fontSize: 10 },
                { text: n2?.users?.services?.name || n2?.users?.directions?.name || '', fontSize: 10 }


              ],
              [
                { text: 'Fonction / Titre :', fontSize: 10 },
                { text: n2?.users?.fonction || '', fontSize: 10 }

              ],
              [ { text: 'Date de prise de service :', fontSize: 10 },
                { text: this.formatDate(n2?.users?.fonctionDate) || '', fontSize: 10 }
              ]
            ]
          },
          layout: 'noBorders'
        })
      }

      return content;
    },


    getAlignment(csRef) {
      const csType = csRef?.champsModel?.typeReponse;
      if (csType === "list" || csType === "string" || !csType) return 'justify';
      if (csType === "double") return 'center';
      return 'right';
    },


    footer: function(currentPage, pageCount) {
      const BLUE = '#005cb9'; // ou [0, 92, 185]
      return {
        stack: [
          { text: "Société des Infrastructures Routières et de l’Aménagement du Territoire (SIRAT SA), Société Anonyme au capital social de 100.000.000 F.CFA -", fontSize: 8, color: BLUE, alignment: 'center' },
          { text: "Siège : Immeuble SCI Trait d’Union, von Obama Beach, Quartier Ahwanleko Plage, Cotonou -", fontSize: 8, color: BLUE, alignment: 'center' },
          {
            columns: [
              { text: "Tél : 21 60 45 45 - IFU : 3 2018 1038 7789 - RCCM RB/COT/18 B 22225 ;", fontSize: 8, color: BLUE, alignment: 'right' },
              { text: "contact@sirat.bj", link: "mailto:contact@sirat.bj", fontSize: 8, color: BLUE, alignment: 'left' }
            ],
            margin: [0, 2, 0, 0]
          },
          { text: `Page ${currentPage} / ${pageCount}`, fontSize: 8, color: BLUE, alignment: 'center', margin: [0, 2, 0, 0] }
        ]
      };
    },





  }
}
</script>
